import { Link } from 'react-router-dom';

interface ProductCardProps {
  href: string;
  name: string;
  price: string;
  originalPrice?: string;
  image: string;
  vendor: string;
  rating?: number;
  reviewCount?: number;
}

export default function ProductCard({
  href,
  name,
  price,
  originalPrice,
  image,
  vendor,
  rating,
  reviewCount = 0
}: ProductCardProps) {
  const showRating = typeof rating === 'number' && reviewCount > 0;

  return (
    <article className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 overflow-hidden group">
      <Link to={href} className="block" aria-label={`Se ${name}`}>
        <div className="relative overflow-hidden aspect-square">
          <img
            src={image}
            alt={name}
            width="300"
            height="300"
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
            loading="lazy"
          />
          {originalPrice && (
            <div className="absolute top-3 left-3 bg-red-500 text-white px-2 py-1 rounded-md text-sm font-medium">
              Tilbud
            </div>
          )}
        </div>

        <div className="p-4">
          <h3 className="font-semibold text-gray-900 mb-2 line-clamp-2 group-hover:text-emerald-600">
            {name}
          </h3>

          {showRating && (
            <div className="flex items-center mb-2" role="img" aria-label={`Bedømmelse: ${rating} ud af 5 stjerner, ${reviewCount} anmeldelser`}>
              <div className="flex items-center">
                {[1, 2, 3, 4, 5].map((i) => (
                  <i
                    key={i}
                    className={`ri-star-${i <= Math.floor(rating!) ? 'fill' : 'line'} text-yellow-400 text-sm`}
                  ></i>
                ))}
              </div>
              <span className="text-gray-500 text-sm ml-2">({reviewCount})</span>
            </div>
          )}

          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center space-x-2">
              <span className="text-xl font-bold text-emerald-600">{price}</span>
              {originalPrice && (
                <span className="text-gray-500 line-through text-sm">{originalPrice}</span>
              )}
            </div>
            <span className="text-gray-500 text-sm">fra {vendor}</span>
          </div>

          <span className="inline-flex items-center justify-center w-full px-4 py-2 text-sm font-medium rounded-lg bg-emerald-600 text-white group-hover:bg-emerald-700">
            Se Produkt
          </span>
        </div>
      </Link>
    </article>
  );
}
